export default __webpack_public_path__ + "static/media/information--tourism-information--g1.e4c2c0fd.png";